import DataStore from '../../stores/DataStore';
import ErrorHandler from '../../utility/ErrorHandler';
import {AuthenticationDataUpdate, ModelDataUpdate, Unauthorized} from '../../Events';
import {CADASTRE_KEY, CLIENT_TOKEN} from '../../SearchParameter';
import {getJSON} from 'jquery'
import {parse as parseQueryString} from 'qs';
import Config from '../../utility/Config'
import Debugger from '../../utility/Debugger'

export function init(tag: any): void {
    setLifecycleHandlers(tag);
}

function setLifecycleHandlers(tag: any): void {
    Debugger.disable();

    const eventHandlers = createEventHandlers(tag);

    tag.on('mount', () => {
        getJSON('config.json', (configJSON: any) => {
            loadConfiguration(configJSON);
            attachEventListeners(eventHandlers);
            tag.authenticated = false;
            actOnQueryStringParameters();
        });
    });

    tag.on('unmount', () => {
        detachEventListeners(eventHandlers);
    });
}

function loadConfiguration(configJSON: any): void {
    Config.loadFromJSON(configJSON);
}

function attachEventListeners(eventHandlers: any): void {
    DataStore.addListener(ModelDataUpdate, eventHandlers[ModelDataUpdate]);
    DataStore.addListener(AuthenticationDataUpdate, eventHandlers[AuthenticationDataUpdate]);
    ErrorHandler.addListener(Unauthorized, eventHandlers[Unauthorized]);
}

function actOnQueryStringParameters(): void {
    const parameters = parseQueryString(window.location.search, {
        ignoreQueryPrefix: true
    });

    if (parameters[CLIENT_TOKEN]) {
        DataStore.setAuthenticationData({
            access_token: parameters[CLIENT_TOKEN]
        });
    }

    if (parameters[CADASTRE_KEY]) {
        // TODO: Validate key
        // FIXME: We should not fetch unless the client is authorized. Disable fetching by qs for now
        // Fetcher.fetchModelData(qsParameterMap[CADASTRE_KEY]);
    }
}

function detachEventListeners(eventHandlers: any): void {
    DataStore.removeListener(ModelDataUpdate, eventHandlers[ModelDataUpdate]);
    DataStore.removeListener(AuthenticationDataUpdate, eventHandlers[AuthenticationDataUpdate]);
    ErrorHandler.removeListener(Unauthorized, eventHandlers[Unauthorized]);
}

function createEventHandlers(tag: any): any {
    return {
        [ModelDataUpdate]: () => {
            tag.update()
        },
        [Unauthorized]: () => {
            tag.authenticated = false;
            tag.update();
        },
        [AuthenticationDataUpdate]: () => {
            tag.authenticated = true;
            tag.update();
        }
    };
}



/** WEBPACK FOOTER **
 ** ./src/components/housingValueSPA/HousingValueSPAController.ts
 **/